import { useQuery } from '@tanstack/react-query';
import { getRoleOrderStatuses } from 'config/requests/ordersBulkUpdate';

type RoleOrderStatusChoice = {
  id: string;
  name: string;
};

export const useRoleOrderStatusChoices = (): RoleOrderStatusChoice[] => {
  const { data } = useQuery({
    queryKey: ['role_order_statuses'],
    queryFn: getRoleOrderStatuses,
  });

  return data?.data.statuses.map(({ alias, name }) => ({ id: alias, name })) ?? [];
};
